export enum TradeParamsEnum {
  instrument = 'instrument',
  notional = 'notional',
  surface = 'surface',
  pv_und = 'pv_und',
  pv_acc = 'pv_acc',
  delta = 'delta',
  delta_percent = 'delta_percent',
  gamma = 'gamma',
  gamma_percent = 'gamma_percent',
  theta = 'theta',
  theta_percent = 'theta_percent',
  vega = 'vega',
  vega_percent = 'vega_percent',
  spot = 'spot',
  vol = 'vol',
  forward = 'forward',
  discount_factor = 'discount_factor',
  token = 'token',
  accounting_token = 'accounting_token',
}

export type TradeValues = {
  [key in TradeParamsEnum]?: string;
};

export type Trade = TradeValues & {
  id: string;
  isClear?: boolean;
  createdAt?: Date;
  overrideItems?: {
    [key in TradeParamsEnum]?: string;
  };
  solveItem?: TradeParamsEnum;
  error?: {
    error: string;
    key: TradeParamsEnum;
  };
  solve_for?: TradeParamsEnum;
  isSolved?: boolean;
};

export const TRADES_PARAMS_LABELS = [
  {
    key: TradeParamsEnum.instrument,
    label: 'Instrument',
    type: 'input',
    placeholder: 'Instrument Grammar',
    align: 'left',
  },
  {
    key: TradeParamsEnum.notional,
    label: 'Notional',
    type: 'input',
    placeholder: 'Notional',
    align: 'left',
  },
  {
    key: TradeParamsEnum.surface,
    label: 'Surface',
    type: 'select',
    placeholder: 'Surface',
    align: 'left',
  },
  {
    key: TradeParamsEnum.pv_und,
    label: 'PV (und)',
    type: 'input',
    placeholder: '-',
    align: 'right',
    canSolve: true,
    override: true,
  },
  {
    key: TradeParamsEnum.pv_acc,
    label: 'PV (acc)',
    type: 'input',
    placeholder: '-',
    align: 'right',
    canSolve: true,
    override: true,
  },
  {
    key: TradeParamsEnum.delta,
    label: 'Delta',
    type: 'value',
    placeholder: '-',
    align: 'right',
  },
  {
    key: TradeParamsEnum.delta_percent,
    label: 'Delta (%)',
    type: 'value',
    placeholder: '-',
    align: 'right',
  },
  {
    key: TradeParamsEnum.gamma,
    label: 'Gamma',
    type: 'value',
    placeholder: '-',
    align: 'right',
  },
  {
    key: TradeParamsEnum.gamma_percent,
    label: 'Gamma (%)',
    type: 'value',
    placeholder: '-',
    align: 'right',
  },
  {
    key: TradeParamsEnum.theta,
    label: 'Theta',
    type: 'value',
    placeholder: '-',
    align: 'right',
  },
  {
    key: TradeParamsEnum.theta_percent,
    label: 'Theta (%)',
    type: 'value',
    placeholder: '-',
    align: 'right',
  },
  {
    key: TradeParamsEnum.vega,
    label: 'Vega',
    type: 'value',
    placeholder: '-',
    align: 'right',
  },
  {
    key: TradeParamsEnum.vega_percent,
    label: 'Vega (%)',
    type: 'value',
    placeholder: '-',
    align: 'right',
  },
  {
    key: TradeParamsEnum.spot,
    label: 'Spot',
    type: 'input',
    placeholder: '-',
    align: 'right',
    override: true,
  },
  {
    key: TradeParamsEnum.vol,
    label: 'Implied Vol',
    type: 'input',
    placeholder: '-',
    align: 'right',
    override: true,
  },
  {
    key: TradeParamsEnum.forward,
    label: 'Fwrd Rate',
    type: 'input',
    placeholder: '-',
    align: 'right',
    override: true,
  },
  {
    key: TradeParamsEnum.discount_factor,
    label: 'DF',
    type: 'input',
    placeholder: '-',
    align: 'right',
    override: true,
  },
];

export const GROUP_TRADES = [
  {
    key: TradeParamsEnum.instrument,
    children: [],
  },
  {
    key: TradeParamsEnum.notional,
    children: [],
  },
  {
    key: TradeParamsEnum.pv_und,
    children: [],
  },
  {
    key: TradeParamsEnum.pv_acc,
    children: [],
  },
  {
    key: TradeParamsEnum.delta,
    children: [TradeParamsEnum.delta_percent],
  },
  {
    key: TradeParamsEnum.gamma,
    children: [TradeParamsEnum.gamma_percent],
  },
  {
    key: TradeParamsEnum.theta,
    children: [TradeParamsEnum.theta_percent],
  },
  {
    key: TradeParamsEnum.vega,
    children: [TradeParamsEnum.vega_percent],
  },
  {
    key: TradeParamsEnum.spot,
    children: [],
  },
  {
    key: TradeParamsEnum.vol,
    children: [],
  },
  {
    key: TradeParamsEnum.forward,
    children: [],
  },
  {
    key: TradeParamsEnum.discount_factor,
    children: [],
  },
];

export const OVERRIDE_MAP: { [key in TradeParamsEnum]?: string } = {
  [TradeParamsEnum.spot]: 'spot_override',
  [TradeParamsEnum.forward]: 'forward_override',
  [TradeParamsEnum.discount_factor]: 'discount_override',
  [TradeParamsEnum.vol]: 'strike_vol_override',
};
